import { VIRAL_TEMPLATE_USE_MOCK } from '@/services/viralTemplate';
import { F_CLOUD_TASK_TYPE } from '@/utils/const';
import type { ResponseProps } from '@/utils/request';

import type { CreationDetail, CreationListResponse, TaskListParams } from '../service';
import viralRaw from './viralMyCreateMockData.json';

/** 将 QA 样本（原 cloudTaskType 501）转为 520，并从 params 里拆出 productName/previewUrl 供 pickPrompt 使用 */
function normalizeTaskExtraForViralPickPrompt(detail: CreationDetail) {
  const items = [...(detail.assetList || []), ...(detail.taskList || [])];
  for (const item of items) {
    const ei = item.extendInfo;
    if (!ei?.taskExtraParam) continue;
    try {
      const root = JSON.parse(ei.taskExtraParam);
      if (root.productName != null || root.previewUrl != null) continue;
      if (typeof root.params === 'string') {
        const inner = JSON.parse(root.params);
        if (inner?.prompt || inner?.image) {
          const preview =
            inner.image ?? (Array.isArray(inner.images) ? inner.images[0] : undefined);
          ei.taskExtraParam = JSON.stringify({
            productName: inner.prompt ?? '',
            previewUrl: preview ?? '',
          });
        }
      }
    } catch {
      /* 保持原始 taskExtraParam */
    }
  }
}

function buildViralMyCreateMockData(): CreationListResponse {
  const data = viralRaw as unknown as CreationListResponse;
  const creationDetailList = (data.creationDetailList || []).map((d) => {
    const detail = {
      ...d,
      batchTaskList: d.batchTaskList ?? [],
      cloudTaskType: F_CLOUD_TASK_TYPE.F_VIRAL_TEMPLATE,
      assetList: (d.assetList || []).map((a) => ({
        ...a,
        cloudTaskType: F_CLOUD_TASK_TYPE.F_VIRAL_TEMPLATE,
      })),
      taskList: (d.taskList || []).map((t) => ({
        ...t,
        cloudTaskType: F_CLOUD_TASK_TYPE.F_VIRAL_TEMPLATE,
      })),
    } as CreationDetail;
    normalizeTaskExtraForViralPickPrompt(detail);
    return detail;
  });
  return { creationDetailList };
}

export function mockViralMyCreateResponse(
  data: TaskListParams,
): ResponseProps<CreationListResponse> {
  const all = buildViralMyCreateMockData().creationDetailList;
  const start = (data.pageNum - 1) * data.pageSize;
  const page = all.slice(start, start + data.pageSize);

  return {
    success: true,
    code: 200,
    message: 'successful',
    requestId: 'mock-viral-my-create',
    data: { creationDetailList: page },
  };
}

/** 与模板列表一致：由 `services/viralTemplate.ts` 的 `VIRAL_TEMPLATE_USE_MOCK` 统一开关 */
export function shouldUseViralMyCreateMock(
  queryTypes: { cloudTaskType: F_CLOUD_TASK_TYPE }[],
) {
  if (!VIRAL_TEMPLATE_USE_MOCK) return false;
  return queryTypes.some((q) => q.cloudTaskType === F_CLOUD_TASK_TYPE.F_VIRAL_TEMPLATE);
}
